import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=07ed9511&scoped=true&"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js&"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedNumber.vue?vue&type=style&index=0&id=07ed9511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ed9511",
  null
  
)

export default component.exports